import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import { experimentalAutoRehydrate } from './utils/redux-persist-store'

import _viewcontrollers from './viewcontrollers/reducer';

import application from './Application/reducer';
import authentication from './Authentication/reducer';
import devices from './connectors/Devices/reducer';
import users from './connectors/Users/reducer';

/* eslint-disable */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
/* eslint-enable */

const rootReducer = experimentalAutoRehydrate(combineReducers({
  _viewcontrollers,
  application,
  authentication,
  devices,
  users,
}));

/**
 * configureStore returns a new store
 * @param  {Object} initialState the initial state
 * @return {Object}              the store
 */
export default function configureStore(initialState) {
  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk)),
  );
}
